module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_jump.0e484.png";